export const ASSISTANT_SERVICE_HOST = 'https://social-media-api.winglegroup.com';

export const SOCIAL_MEDIA_SCRAPER_PATHS = {
  instagram: `${ASSISTANT_SERVICE_HOST}/api/instagram/results`,
  facebook: `${ASSISTANT_SERVICE_HOST}/api/facebook/results`,
  x: `${ASSISTANT_SERVICE_HOST}/api/x/results`,
  youtube: `${ASSISTANT_SERVICE_HOST}/api/youtube/results`,
  linkedin: `${ASSISTANT_SERVICE_HOST}/api/linkedin/results`,
  all: `${ASSISTANT_SERVICE_HOST}/api/all/results`,
  productTypes: `${ASSISTANT_SERVICE_HOST}/api/product_types`,
  applications: `${ASSISTANT_SERVICE_HOST}/api/applications`,
  effects: `${ASSISTANT_SERVICE_HOST}/api/effects`,
  newLaunches: `${ASSISTANT_SERVICE_HOST}/api/new-launches`,
  ingredients: `${ASSISTANT_SERVICE_HOST}/api/ingredients`,
  extraKeywords: `${ASSISTANT_SERVICE_HOST}/api/extra-keywords`,
  coreAccounts: `${ASSISTANT_SERVICE_HOST}/api/core-accounts`,
  coreResults: `${ASSISTANT_SERVICE_HOST}/api/core/results`,
  coreSessions: `${ASSISTANT_SERVICE_HOST}/api/core/sessions`,
  coreResultsExport: `${ASSISTANT_SERVICE_HOST}/api/core/results/export`,
};
